import type { BrandReportTimespan } from '@mnd-frontend/graphql-schema';
import type { TranslationFunction } from '../types';

const defaultDescription = ({
  sectionType,
  t,
}: {
  sectionType: string;
  t: TranslationFunction;
}) => {
  switch (sectionType) {
    case 'ReportVisibilitySection':
      return t('reports_visibility_section_description');
    case 'ReportPerceptionSection':
      return t('reports_perception_section_description');
    case 'ReportVisibilityBenchmarkSection':
      return t('reports_visibility_benchmark_section_description');
    case 'ReportPerceptionBenchmarkSection':
      return t('reports_share_benchmark_section_description');
  }
  return '';
};

export const getDefaultSectionDescription = ({
  section,
  t,
}: {
  section: { __typename: string; description?: string | null };
  brand?: string;
  compareToPreviousYear?: boolean;
  timespan?: BrandReportTimespan;

  t: TranslationFunction;
}) => {
  return section.description === null
    ? defaultDescription({
        sectionType: section.__typename,
        t,
      })
    : (section.description ?? '');
};
